import { render, staticRenderFns } from "./BlockListSelfServiceCustom.vue?vue&type=template&id=1beecb7a&"
import script from "./BlockListSelfServiceCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListSelfServiceCustom.vue?vue&type=script&lang=js&"
import style0 from "./BlockListSelfServiceCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports